import { FC, useCallback } from "react";
import { useFlag } from "@unleash/proxy-client-react";
import { useNavigate } from "react-router-dom";
import { CommitmentsPageHeaderMetadataCard } from "@/components/pages/commtiments/common/components/metadata-card/CommitmentsPageHeaderMetadataCard";
import { money } from "@/utils/numeral/money";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { commitmentsCurrentOrgIdSelector } from "@/store/commitments/selectors/common/commitmentsCurrentOrgIdSelector";
import {
  CommitmentType,
  useGetUsersMeOrganisationsCurrentCommitmentsPotentialSavingsQuery,
} from "@/services/cloudchipr.api";
import {
  setCommitmentsDataViewTab,
  setCommitmentsTypeTab,
} from "@/store/commitments/commitmentsSlice";

export const CommitmentsOverviewMetadataPotentialSavingsCard: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const orgId = useAppSelector(commitmentsCurrentOrgIdSelector);
  const enableReservationRecommendation = useFlag(
    "EnableReservationRecommendation",
  );
  const { data, isLoading } =
    useGetUsersMeOrganisationsCurrentCommitmentsPotentialSavingsQuery({
      providerOrganisationId: orgId,
    });

  const handleChipItemClick = useCallback(
    (commitmentType: CommitmentType) => {
      const dataViewTab =
        commitmentType === "savings_plan" ? "commitment" : "reservation";
      dispatch(setCommitmentsTypeTab("recommendation"));
      dispatch(setCommitmentsDataViewTab(dataViewTab));
      navigate({ search: `active=recommendation` });
    },
    [dispatch, navigate],
  );

  if (!enableReservationRecommendation) {
    return null;
  }

  return (
    <CommitmentsPageHeaderMetadataCard
      primary="Potential Savings"
      loading={isLoading}
      valueColor="success.light"
      value={
        data?.savings_amount !== null
          ? `~${money(data?.savings_amount)}`
          : "N/A"
      }
      valueUnit="mo"
      tooltip="Total amount of potential savings based on Commitments Recommendations."
      sx={{ flex: 1 }}
      chipData={{
        reservedInstances: {
          value: data?.reservations_total_amount
            ? money(data?.reservations_total_amount)
            : "N/A",
          tooltipTitle: "View Reservations Potential Savings",
        },
        savingsPlans: {
          value: data?.savings_plan_total_amount
            ? money(data?.savings_plan_total_amount)
            : "N/A",
          tooltipTitle: "View Savings Plans Potential Savings",
        },
        onClick: handleChipItemClick,
      }}
    />
  );
};
